var map = {
	"./A_Kedar_Shenoy.pdf": 7986,
	"./Browser.png": 9570,
	"./Comp/BooleanmathsLogoNew.svg": 4960,
	"./Comp/BooleanmathsLogoSquare.svg": 9151,
	"./Comp/Connectia.png": 3128,
	"./Comp/ConnectiaLogo.svg": 4835,
	"./Comp/TorsecureLogoLeft.svg": 348,
	"./Comp/torsecure.png": 6332,
	"./Company/booleanmaths.svg": 4035,
	"./Company/conectia.svg": 9300,
	"./Company/torsecure.svg": 4498,
	"./Discord.png": 8098,
	"./Hero.png": 6468,
	"./Linkdin.png": 3707,
	"./Mail.png": 1893,
	"./Telegram.png": 8557,
	"./Twiter.png": 8513,
	"./WorkProjects/Medront 2.mp4": 9614,
	"./WorkProjects/Medront 3.mp4": 8067,
	"./WorkProjects/booleanmaths_attribution.png": 5361,
	"./WorkProjects/booleanmaths_audience_builder.png": 2498,
	"./WorkProjects/booleanmaths_audience_detail.png": 4964,
	"./WorkProjects/booleanmaths_capi_data.png": 2770,
	"./WorkProjects/booleanmaths_capi_events.png": 8953,
	"./WorkProjects/booleanmaths_capi_setup.png": 5895,
	"./WorkProjects/booleanmaths_capi_stats.png": 2865,
	"./WorkProjects/booleanmaths_connections.png": 3601,
	"./WorkProjects/booleanmaths_creative_attribution.png": 369,
	"./WorkProjects/booleanmaths_health_check.png": 9243,
	"./WorkProjects/booleanmaths_journey_builder.png": 2418,
	"./WorkProjects/booleanmaths_landing.png": 8807,
	"./WorkProjects/booleanmaths_landing_2.png": 576,
	"./WorkProjects/booleanmaths_survey_perf.png": 9762,
	"./WorkProjects/booleanmaths_survey_report.png": 2965,
	"./WorkProjects/booleanmaths_survey_setup.png": 3668,
	"./WorkProjects/booleanmaths_utm_fix.png": 7742,
	"./WorkProjects/medront 1.mp4": 4465,
	"./WorkProjects/medront_landing.png": 4013,
	"./WorkProjects/shopify_app_admin.png": 4186,
	"./WorkProjects/shopify_app_store.png": 2892,
	"./about.png": 2789,
	"./certificates.png": 6804,
	"./contact.png": 3222,
	"./cv.png": 7339,
	"./home.png": 37,
	"./plus.svg": 4242,
	"./work.png": 3231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4082;